var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"oai_detail"},[_c('li',[_vm._v(_vm._s(_vm.occupation))]),_c('li',[_vm._v(_vm._s(_vm.name))]),_c('li',[_vm._v(_vm._s(_vm.startTimeStr))]),(_vm.showEndTime)?_c('li',[_vm._v(_vm._s(_vm.endTimeStr))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }